import ClickHelper from "./Click";

export default class PseudoHelper {
    static isClickTarget(event, pseudo = 'before') {
        let el      = $(event.currentTarget);

        let padLeft     = el.innerWidth() - el.width(),
            padTop      = parseInt( window.getComputedStyle( el[0], '::' + pseudo ).height ),
            offset      = ClickHelper.getClickOffset(event);

        if( offset.x > padLeft || offset.Y > padTop ) return false;

        return true;
    }
}